/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Openquestionstitlemany3Inputs */

const en_openquestionstitlemany3 = /** @type {(inputs: Openquestionstitlemany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} open questions about your case`)
};

const pt_openquestionstitlemany3 = /** @type {(inputs: Openquestionstitlemany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pontos a esclarecer sobre o seu processo`)
};

/**
* | output |
* | --- |
* | "{count} open questions about your case" |
*
* @param {Openquestionstitlemany3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionstitlemany3 = /** @type {((inputs: Openquestionstitlemany3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionstitlemany3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionstitlemany3(inputs)
	return pt_openquestionstitlemany3(inputs)
});
export { openquestionstitlemany3 as "openQuestionsTitleMany" }